<template>
  <div class="content">
    <img src="@/assets/img/phone.png" alt="">
    <p>请使用手机浏览器</p>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  created() {

  },
  methods:{

  }
}
</script>
<style lang="less" scoped>
.content{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    width: 100px;
    height: 100px;
  }
  p{text-align: center;}
}
</style>